import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#f7fafc] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img
              src="https://static.readdy.ai/image/5599338006c54fe6ce07ff64cfd8f48c/4f72f15ed9b284405d9fe611c977c9b0.png"
              alt="Security Services"
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-gray-600 leading-relaxed">
              Professional security solutions for CCTV, access control, and building security systems.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-[#1a2b4a] mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-sm text-gray-600 hover:text-[#1a2b4a] transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/tour" className="text-sm text-gray-600 hover:text-[#1a2b4a] transition-colors cursor-pointer">
                  Solutions Tour
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-[#1a2b4a] transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/contact#consultation" className="text-sm text-gray-600 hover:text-[#1a2b4a] transition-colors cursor-pointer">
                  Schedule Consultation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold text-[#1a2b4a] mb-4">Contact Information</h3>
            <ul className="space-y-2">
              <li className="flex items-start text-sm text-gray-600">
                <i className="ri-phone-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>(647) 280-0088</span>
              </li>
              <li className="flex items-start text-sm text-gray-600">
                <i className="ri-mail-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>info@inoffice.ca</span>
              </li>
              <li className="flex items-start text-sm text-gray-600">
                <i className="ri-time-line mr-2 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>Mon-Fri: 7:00 AM - 6:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-xs text-gray-500 mb-4 md:mb-0">
            © 2025 Security Services. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-gray-500 hover:text-[#1a2b4a] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
